module.exports = __webpack_public_path__ + "static/volunteer_6_1920-089721b3fff1106716f709ed35394d99.jpg";